import { render } from "./ChangeInformation.vue?vue&type=template&id=4d126f72&scoped=true"
import script from "./ChangeInformation.vue?vue&type=script&lang=js"
export * from "./ChangeInformation.vue?vue&type=script&lang=js"

import "./ChangeInformation.vue?vue&type=style&index=0&id=4d126f72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d126f72"

export default script